import React from "react";
import {imageUrl} from "../../helpers/ApplicationHelper";

const BlackBox = ({ caption, onClickMe }) => {
    return <span onClick={ onClickMe } className="black-box text-center">
        <img className="lock" src={imageUrl('lightListing/lock_soft.svg')}/>
        <span className="black-box-caption">{caption}</span>
    </span>
};

export default BlackBox;
